import { render, staticRenderFns } from "./TopOfficeEncountersWidget.vue?vue&type=template&id=1ddfb938&scoped=true&"
import script from "./TopOfficeEncountersWidget.vue?vue&type=script&lang=js&"
export * from "./TopOfficeEncountersWidget.vue?vue&type=script&lang=js&"
import style0 from "./TopOfficeEncountersWidget.vue?vue&type=style&index=0&id=1ddfb938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfb938",
  null
  
)

export default component.exports